import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Link } from 'react-router-dom';

import { PageBreadcrumb, TextButton } from '@zillow/constellation';
import { Container } from '@zillow/zrs-comet';

import { RMWContext } from 'app/shared/providers/RMWContext';
import ConnectedPropertyCard from 'app/shared/components/ConnectedPropertyCard';
import FindTenantsPage from 'app/shared/containers/FindTenantsPage';
import ManageTenantsPage from 'app/shared/containers/ManageTenantsPage';
import { CHILD_ROUTE } from './constants';

const TenantsPage = ({
    match,
}) => {
    const { paths } = useContext(RMWContext);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    // remove trailing slash
    match.url = match.url.replace(/\/$/, '');
    const getPath = section => `${match.url.replace(`/${section}`, '')}/${section}`;

    const renderChildRoutes = () => (
        <Switch>
            <Route
                path={getPath(CHILD_ROUTE.FIND_TENANTS)}
                component={FindTenantsPage}
            />
            <Route
                path={getPath(CHILD_ROUTE.MANAGE_TENANTS)}
                component={ManageTenantsPage}
            />
        </Switch>
    );

    const onFetchError = () => setHasError(true);
    const onFetchComplete = () => setIsLoading(false);

    return (
        <Container
            className="TenantsPage"
            fluidMobile={true}
            marginBottom="xl"
        >
            <PageBreadcrumb
                backButton={(
                    <TextButton
                        as={Link}
                        to={paths.propertiesPage}
                    >
                        Properties
                    </TextButton>
                )}
            />
            <ConnectedPropertyCard match={match} onFetchError={onFetchError} onFetchComplete={onFetchComplete} />
            {!isLoading && !hasError && renderChildRoutes()}
        </Container>
    );
};

TenantsPage.propTypes = {
    match: PropTypes.object.isRequired,
};

export default TenantsPage;
